export const gpaRoutesData2025 = [
    {
        name: 'CSE',
        to: '/gpa2025/cse2025',
        expansion: 'Computer Science and Engineering'
    },
    {
        name: 'IT',
        to: '/gpa2025/it2025',
        expansion: 'Information Technology'
    },
    {
        name: 'AIML',
        to: '/gpa2025/aiml2025',
        expansion: 'Artificial Intelligence And Machine Learning'
    },
    {
        name: 'CSD',
        to: '/gpa2025/csd2025',
        expansion: 'Computer Science and Design'
    },
    {
        name: 'CSB',
        to: '/gpa2025/csb2025',
        expansion: 'Computer Science and Business Intelligence'
    },
    {
        name: 'CSECS',
        to: '/gpa2025/csecs2025',
        expansion: 'Computer Science and Engineering (Cyber Security)'
    },
    {
        name: 'ECE',
        to: '/gpa2025/ece2025',
        expansion: 'Electronics and Communication Engineering'
    },
    {
        name: 'EEE',
        to: '/gpa2025/eee2025',
        expansion: 'Electrical and Electronics Engineering'
    },
    {
        name: 'MECH',
        to: '/gpa2025/mech2025',
        expansion: 'Mechanical Engineering'
    },
    {
        name: 'CIVIL',
        to: '/gpa2025/civil2025',
        expansion: 'Civil Engineering'
    },
    {
        name: 'BME',
        to: '/gpa2025/auto2025',
        expansion: 'Bio Medical Engineering'
    },
    // adding 7 new deparments
    {
        name: 'FT',
        to: '/gpa2025/ft2025',
        expansion: 'Fashion Technology'
    },
    {
        name: 'MCT',
        to: '/gpa2025/mct2025',
        expansion: 'Mechatronics Engineering'
    },
    {
        name: 'ADS',
        to: '/gpa2025/ads2025',
        expansion: 'Artificial Intelligence and Data Science'
    },
    {
        name: 'EFE',
        to: '/gpa2025/ecce2025',
        expansion: 'Electrical and Computer Engineering'
    },
    {
        name: 'EXE',
        to: '/gpa2025/eece2025',
        expansion: 'Electronics and Computer Engineering'
    },
    {
        name: 'FSE',
        to: '/gpa2025/fse2025',
        expansion: 'Safety and Fire Engineering'
    },
        {
        name: 'VLSI',
        to: '/gpa2025/vlsi2025',
        expansion: 'Electronics Engineering (VLSI Design and Tech)'
    },
]

